const CONSTANTS = {
    MODE_CLOSEST: 'closest',
    TRIGGER_CLASS: 'animation__trigger',
    TARGET_CLASS: 'animation__target',
    DIRECTION_NEXT: 'next',
    DIRECTION_PREV: 'prev',
    ANIMATION_CLASS_DURATION: 'animation__duration--500',
    ANIMATION_CLASS_TYPE: 'animation__type--expand',
    ANIMATION_DIRECTION_FORWARDS: 'animation__direction--forwards',
    ANIMATION_DIRECTION_REVERSE: 'animation__direction--reverse',
    ANIMATION_TOGGLE: 'true',
};

const actions = {
    beforeAnimation: (target) => {
        if (target.style.display === 'none') {
            target.style.display = 'block';
        }
    },
    afterAnimation: (target) => {
        if (!target.style.display) {
            target.style.display = 'none';
        } else {
            if (target.classList.contains(options.animation.forwards)) {
                target.style.display = 'block';
            } else {
                target.style.display = 'none';
            }
        }

        if (!target.classList.contains(options.animation.reverse) && !target.classList.contains(options.animation.forwards)) {
            target.classList.add(options.animation.forwards);
        } else {
            if (target.classList.contains(options.animation.forwards)) {
                target.classList.remove(options.animation.forwards);
                target.classList.add(options.animation.reverse);
            } else {
                target.classList.remove(options.animation.reverse);
                target.classList.add(options.animation.forwards);
            }
        }
    },
    findClosestTarget: (element) => {
        let parentTrigger = element.closest(`.${options.classes.parent}`);

        if (!parentTrigger) {
            new Error(`Could not find parent with class ${options.classes.parent}`)
        }

        let target;
        if (options.directions === CONSTANTS.DIRECTION_PREV) {
            target = parentTrigger.previousElementSibling;
            while (target && !target.classList.contains(options.classes.target)) {
                target = target.previousElementSibling;
            }
        } else {
            target = parentTrigger.nextElementSibling;
            while (target && !target.classList.contains(options.classes.target)) {
                target = target.nextElementSibling;
            }
        }

        if (target.classList.contains(options.classes.target)) {
            return target;
        } else {
            new Error(`Could not find sibling with class ${options.classes.target}`);
        }
    }
};

const eventHandlers = {
    click: (e) => {
        const closestTarget = actions.findClosestTarget(e.currentTarget);
        actions.beforeAnimation(closestTarget);
        closestTarget.classList.add(options.animation.duration);
        closestTarget.classList.add(options.animation.type);
    },
    animationStart: () => {

    },
    animationEnd: (e) => {
        actions.afterAnimation(e.currentTarget);
        e.currentTarget.classList.remove(options.animation.duration);
        e.currentTarget.classList.remove(options.animation.type);
    }
};

let options = {
    eventType: 'click',
    handler: {
        trigger: eventHandlers.click,
        animationStart: eventHandlers.animationStart,
        animationEnd: eventHandlers.animationEnd
    },
    findTarget: CONSTANTS.MODE_CLOSEST,
    directions: CONSTANTS.DIRECTION_NEXT,
    classes: {
        trigger: CONSTANTS.trigger,
        target: CONSTANTS.target,
        parent: CONSTANTS.trigger
    },
    animation: {
        duration: CONSTANTS.ANIMATION_CLASS_DURATION,
        type: CONSTANTS.ANIMATION_CLASS_TYPE,
        forwards: CONSTANTS.ANIMATION_DIRECTION_FORWARDS,
        reverse: CONSTANTS.ANIMATION_DIRECTION_REVERSE,
        toggle: CONSTANTS.ANIMATION_TOGGLE
    }
};

const animation = {
    init: (optionOverwrites) => {
        Object.assign(options, optionOverwrites);

        let triggerElements = document.querySelectorAll(`.${options.classes.trigger}`);
        let targetElements = document.querySelectorAll(`.${options.classes.target}`);

        if (!targetElements) {
            new Error(`Could not find elements with class ${options.classes.target}`);
        }

        if (!triggerElements) {
            new Error(`Could not find elements with class ${options.classes.trigger}`);
        } else {
            triggerElements.forEach((trigger) => {
                // init targets
                const closestTarget = actions.findClosestTarget(trigger);
                if (!window.IS_AUTOMATED_TESTING) {
                    actions.afterAnimation(closestTarget);
                }
                closestTarget.addEventListener('animationstart', options.handler.animationStart);
                closestTarget.addEventListener('animationend', options.handler.animationEnd);
                trigger.addEventListener(options.eventType, options.handler.trigger);
                trigger.addEventListener('simulatedClick', options.handler.trigger);
            });
        }
    },
    options: options,
    actions: actions,
    events: eventHandlers
};

export { animation };
